module.exports = __webpack_public_path__ + "static/media/preplay-unresolved.cc4b0e10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preplay-unresolved.svg
// module id = ./src/assets/images/preplay-unresolved.svg
// module chunks = 0